import type {
  PaymentProfileAddress,
  PaymentProfileCard,
} from "../../services/pagbank";

export const emptyAddr: PaymentProfileAddress = {
  street: "",
  number: "",
  complement: "",
  district: "",
  city: "",
  state: "",
  postal_code: "",
};

export const emptyCard: PaymentProfileCard = {
  number: "",
  holder_name: "",
  expiry_month: "",
  expiry_year: "",
  cvv: "",
};
